import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-bootstrap'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import '../style.css'

// import { userRegionIsEU } from '../../../functions/userPermissions'

import {
  handleAdditionalAntimicrobialsFieldChange,
  submitAdditionalAntimicrobial,
  deleteAdditionalAntimicrobial,
 } from '../reducers/antibioticsUseFormReducer'
 import {
   handleChartFieldChange,
 } from '../reducers/chartFormReducer'

import ConfirmationPopover from '../../../components/ConfirmationPopover'


const Antimicrobial = (props) => {

  const {
    id,
    drug_name,
    initiation_date,
    end_date,
    chartForReview,
    dateErrorMessage,
  } = props

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleAdditionalAntimicrobialsFieldChange(id, name, value)
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (dateErrorMessage && dateErrorMessage !== '' && dateErrorMessage.includes('[')) {
        let name = dateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          let split = name.split(', ')
          if (split.includes(`${key}`)) {
            return dateErrorMessage.split('[')[0]
          } else {
            return 'Date is Invalid'
          }
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const handleDateChange = (name, date) => {

    if ((date instanceof Date && !isNaN(date)) || date === null) {
      props.handleAdditionalAntimicrobialsFieldChange(id, name, date)
    } else {
      props.handleAdditionalAntimicrobialsFieldChange(id, name, null)
    }
    props.handleChartFieldChange('chartDateErrorMessage', '')
    const antimicrobial = { ...props, [name]: date, dateNameToCheckForError: name }
    return props.submitAdditionalAntimicrobial(antimicrobial)
  }

  const handleBlur = () => {
    const antimicrobial = { ...props, dateNameToCheckForError: 'initiation_date' }
    props.submitAdditionalAntimicrobial(antimicrobial)
  }

  const handleRemove = () => {
    return props.deleteAdditionalAntimicrobial(props)
  }

  const handleDateKeyDown = (e) => {
    if (!e || !e.key || (e.key !== "Backspace" && e.key !== "Delete")) {
      return e.preventDefault()
    }
  }

  const popoverContent = (
    <div>
      <p>Remove antimicrobial <strong>{drug_name}</strong>?</p>
      <br/>
      <p>This action will <strong>delete the antimicrobial from the database</strong>.</p>
    </div>
  )

  let datePickerFormat = "MMMM d,  yyyy"

  return (
    <tr className="antimicrobial-row">
      {chartForReview ?
        null
        :
        <td className='form-input-td'>
          <center>
            <ConfirmationPopover
              triggerText='x'
              title='Delete Antimicrobial?'
              placement='right'
              popoverContent={popoverContent}
              onConfirm={handleRemove}
            />
          </center>
        </td>
        }
      <td className='form-input-td'>
        <Form.Control
          type='text'
          name='drug_name'
          value={drug_name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Enter the name of the antimicrobial used'
          disabled={props.chartForReview}
          required={true}
        />
      </td>


      <td className='date-td'>
       <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            style={{ background: 'white' }}
            disabled={props.chartForReview}
            margin="normal"
            label='Please select a date'
            format={datePickerFormat}
            value={initiation_date}
            required={true}
            helperText={getHelperText('initiation_date')}
            onChange={(date) => handleDateChange('initiation_date', date)}
            onKeyDown={handleDateKeyDown}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            allowKeyboardControl={false}
          />
       </MuiPickersUtilsProvider>
      </td>

      <td className='date-td'>
       <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            style={{ background: 'white' }}
            disabled={props.chartForReview}
            margin="normal"
            label='Please select a date'
            format={datePickerFormat}
            value={end_date}
            required={true}
            helperText={getHelperText('end_date')}
            onChange={(date) => handleDateChange('end_date', date)}
            onKeyDown={handleDateKeyDown}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            allowKeyboardControl={false}
          />
       </MuiPickersUtilsProvider>
      </td>
    </tr>
  )
}

const mapStateToProps = (state) => {
  return {
    antibiotics_use: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    handleAdditionalAntimicrobialsFieldChange: (id, name, value) => {
      return dispatch(handleAdditionalAntimicrobialsFieldChange(id, name, value))
    },

    submitAdditionalAntimicrobial: (props) => {
      return dispatch(submitAdditionalAntimicrobial(props))
    },

    deleteAdditionalAntimicrobial: (props) => {
      return dispatch(deleteAdditionalAntimicrobial(props))
    },

    handleChartFieldChange: (key, value) => {
      return dispatch(handleChartFieldChange(key, value))
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Antimicrobial)
